import React from 'react';
import PropTypes from 'prop-types';

import { observer } from 'mobx-react';

import Lottie from 'react-lottie';
import wfLoader from 'assets/lotties/wf-loader-black.json';

import { GltfLoadingStyled, TextStyled } from './loading.styled';

const GltfLoading = observer(props => {
  const {
    isLayoutCentered = true,
    aboveEverything = false,
    text = '',
    size = 60,
    paused = false,
    visible = true,
    noText = false,
    dataTestId = 'loadingSpinner',
  } = props;
  const defaultOptions = {
    loop: true,
    autoplay: true,
    renderer: 'svg',
    animationData: wfLoader,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  if (!visible) {
    return null;
  }
  if (paused) {
    defaultOptions.autoplay = false;
  }
  return (
    <GltfLoadingStyled
      data-testid={dataTestId}
      isLayoutCentered={isLayoutCentered}
      aboveEverything={aboveEverything}
      role='alert'
      aria-live='assertive'
      canvasWidth={props.canvasWidth}
    >
      <Lottie
        options={defaultOptions}
        isPaused={paused}
        height={size}
        width={size}
      />
      {!noText && <TextStyled>{text}</TextStyled>}
      {props.children}
    </GltfLoadingStyled>
  );
});
export default GltfLoading;

GltfLoading.propTypes = {
  isLayoutCentered: PropTypes.bool,
  aboveEverything: PropTypes.bool,
  text: PropTypes.string,
  paused: PropTypes.bool,
};
